export default __webpack_public_path__ + "static/Smeeta_Khetarpaul_BW-c5ba08cec3ecae43d3133165a435368c.jpg";